module.exports = __webpack_public_path__ + "static/media/image4.7eb16122.svg";